module.exports = __webpack_public_path__ + "static/img/fot1.15b65f32.png";